import * as React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { SelectBox } from 'sos-common/js/components/FormControls/SelectBox';
import { CheckBox } from 'sos-common/js/components/FormControls/CheckBox';
import { FormFieldString, FormFieldBoolean } from 'sos-common/js/commonTypes/formField.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { allScopedResearchOrderFiles2SelectBoxOptions, getErrorMessageByFieldName } from '../../utilities/helpers';
import {
  RegisterPeriodClarificationItemProps,
  RegisterPeriodClarificationItemState,
  RegBoundClarification,
} from './Clarification.types';
import { RegisterPeriodClarification } from '../../models/ResearchOrderModel';
import { researchOrderFiles, ResearchOrderStore } from '../../models/ResearchOrderStore.types';

class ClarificationItem extends React.Component<
  RegisterPeriodClarificationItemProps,
  RegisterPeriodClarificationItemState
> {
  static defaultProps = {
    reg: {} as RegBoundClarification,
    onUpdate: () => {},
    onClear: () => {},
    files: {} as researchOrderFiles,
    errorAriaAttributes: null,
  } as RegisterPeriodClarificationItemProps;

  constructor(props: any) {
    super(props);
  }

  componentDidMount = () => {
    const { index } = this.getRegBoundClarification();
    const start = document.getElementById(`StartDate_${index}`);
    const end = document.getElementById(`EndDate_${index}`);
    const dateFields = [start, end];

    const disallowedChars = ['E', 'e', '.', ','];

    //.foreach() does not work in IE
    for (let index = 0; index < dateFields.length; index++) {
      const element = dateFields[index];

      //Disable pasting
      element?.addEventListener('paste', (e: ClipboardEvent) => {
        e.preventDefault();
      });

      //Disable input of disallowed characters
      element?.addEventListener('keydown', (e: KeyboardEvent) => {
        const keyPressed = e.key.toString();
        if (disallowedChars.includes(keyPressed)) {
          e.preventDefault();
        }
      });
    }
  };

  //props.onUpdate method expects to receive this object
  getRegBoundClarification = (): RegBoundClarification => {
    const { reg } = this.props;
    return {
      clarification: reg.clarification || ({ Register: this.props.reg.Name } as RegisterPeriodClarification),
      isSelected: !!reg.isSelected,
      index: reg.index,
      DhsId: reg.DhsId,
      Name: reg.Name,
      touchedMap: reg.touchedMap || new Map(),
    };
  };

  handleChange = (fieldName: string, reg: RegBoundClarification) => {
    reg.touchedMap.set(fieldName, true);
    this.props.onUpdate(reg);
  };

  onChangeFrom = (field: FormFieldString) => {
    const reg = this.getRegBoundClarification();
    reg.clarification.StartDate = parseInt(field.value, 10);
    this.handleChange(field.fieldName, reg);
  };
  onChangeTo = (field: FormFieldString) => {
    const reg = this.getRegBoundClarification();
    reg.clarification.EndDate = parseInt(field.value, 10);
    this.handleChange(field.fieldName, reg);
  };

  onChangeFile = (file: FormFieldString) => {
    const reg = this.getRegBoundClarification();
    reg.clarification.FileInfo = { ...reg.clarification.FileInfo, FileId: file.value };
    this.handleChange(file.fieldName, reg);
  };

  onChangePage = (file: FormFieldString) => {
    const reg = this.getRegBoundClarification();
    reg.clarification.FileInfo = { ...reg.clarification.FileInfo, Page: file.value };
    this.handleChange(file.fieldName, reg);
  };

  handleSelectRegistry = (field: FormFieldBoolean) => {
    const reg = this.getRegBoundClarification();
    reg.isSelected = field.value;
    reg.clarification = field.value ? ({ Register: reg.Name } as RegisterPeriodClarification) : null;
    reg.touchedMap = new Map();
    this.handleChange(field.fieldName, reg);
  };

  public render() {
    const { files, strings, fullValidationResults, hasHitSummary, errorAriaAttributes } = this.props;
    const reg = this.getRegBoundClarification();
    const { isSelected, clarification, Name: name, DhsId: dhsId, index, touchedMap } = reg;
    return (
      <div key={dhsId}>
        <div className="form-group-sx-small">
          <div>
            <CheckBox
              value={isSelected}
              fieldName={`CurrentResearchOrder.InternalRegisters[${index}]`}
              id={`${dhsId}_checkbox`}
              label={name}
              onChange={this.handleSelectRegistry}
              errorAriaAttributes={errorAriaAttributes}
            />
          </div>
          {isSelected && (
            <div className="indent">
              <div className="row form-group-small">
                <div className="col-md-6">
                  <TextInput
                    id={`StartDate_${index}`}
                    type="number"
                    classNames="no-spinner"
                    label={strings.StartDate.label}
                    placeholder={strings.StartDate.placeholder}
                    value={clarification.StartDate != null ? String(clarification.StartDate) : ''}
                    fieldName={`CurrentResearchOrder.RegisterPeriodClarifications[${index}].StartDate`}
                    errorMessage={
                      touchedMap.get(`CurrentResearchOrder.RegisterPeriodClarifications[${index}].StartDate`) ||
                      hasHitSummary
                        ? getErrorMessageByFieldName(
                            fullValidationResults,
                            `RegisterPeriodClarifications[${index}].StartDate`,
                          )
                        : ''
                    }
                    onChange={this.onChangeFrom}
                  />
                </div>
                <div className="col-md-6">
                  <TextInput
                    id={`EndDate_${index}`}
                    type="number"
                    classNames="no-spinner"
                    label={strings.EndDate.label}
                    placeholder={strings.EndDate.placeholder}
                    value={clarification.EndDate != null ? String(clarification.EndDate) : ''}
                    fieldName={`CurrentResearchOrder.RegisterPeriodClarifications[${index}].EndDate`}
                    errorMessage={
                      touchedMap.get(`CurrentResearchOrder.RegisterPeriodClarifications[${index}].EndDate`) ||
                      hasHitSummary
                        ? getErrorMessageByFieldName(
                            fullValidationResults,
                            `RegisterPeriodClarifications[${index}].EndDate`,
                          )
                        : ''
                    }
                    onChange={this.onChangeTo}
                  />
                </div>
              </div>
              <div className="row form-group-small">
                <div className="col-md-6">
                  <label>{strings.FileId.label}</label>
                  <SelectBox
                    options={allScopedResearchOrderFiles2SelectBoxOptions(files)}
                    value={_.get(clarification, 'FileInfo.FileId')}
                    fieldName={`CurrentResearchOrder.RegisterPeriodClarifications[${index}].FileInfo.FileId`}
                    errorMessage={
                      touchedMap.get(`CurrentResearchOrder.RegisterPeriodClarifications[${index}].FileInfo.FileId`) ||
                      hasHitSummary
                        ? getErrorMessageByFieldName(
                            fullValidationResults,
                            `RegisterPeriodClarifications[${index}].FileInfo.FileId`,
                          )
                        : ''
                    }
                    onChange={this.onChangeFile}
                  />
                </div>
                <div className="col-md-6">
                  <TextInput
                    label={strings.Page.label}
                    placeholder={strings.Page.placeholder}
                    maxLength={50}
                    value={_.get(clarification, 'FileInfo.Page')}
                    fieldName={`CurrentResearchOrder.RegisterPeriodClarifications[${index}].FileInfo.Page`}
                    errorMessage={
                      touchedMap.get(`CurrentResearchOrder.RegisterPeriodClarifications[${index}].FileInfo.Page`) ||
                      hasHitSummary
                        ? getErrorMessageByFieldName(
                            fullValidationResults,
                            `RegisterPeriodClarifications[${index}].FileInfo.Page`,
                          )
                        : ''
                    }
                    onChange={this.onChangePage}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapState2Props = (state: ResearchOrderStore) => {
  return {
    registers: state.registers,
    files: state.files,
    validationResults: state.validationState.validationResults,
    fullValidationResults: state.validationState.fullValidationResults,
    hasHitSummary: state.globals.hasHitSummary,
  };
};

export default connect(mapState2Props)(ClarificationItem);
